import React, { createContext, useState } from 'react'

export const UserContext = createContext({})

export const UserProvider = ({ children }) => {

    const [skillTab, setSkillTab] = useState(false)

    const TrueState = () => {
        setSkillTab(true)
    }

    const FalseState = () => {
        setSkillTab(false)
    }

  return (
    <UserContext.Provider value={{skillTab, TrueState, FalseState}}>
        { children }
    </UserContext.Provider>
  )
}
